module.exports = __webpack_public_path__ + "img/beta-icon.f60d5010.png";